// extracted by mini-css-extract-plugin
module.exports = {"layout":"speaker-card_layout__gQur1","photoContainer":"speaker-card_photoContainer__Npah2","photo":"speaker-card_photo__18fRx"};